const cartState = {
  search_event:
        {
          event : {}
        }
}

export { cartState }
